module.exports = __webpack_public_path__ + "static/img/GlennMcFarlane.b6d56e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GlennMcFarlane.jpg
// module id = PPcO
// module chunks = 0